var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVtele(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_866",
    "data-name": "Group 866",
    transform: "translate(572 1821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M15.015,30.031a.98.98,0,0,1-.382-.076,1,1,0,0,1-.619-.925V23.022a1.008,1.008,0,0,1,.292-.709l4.726-4.726-7.528,4.3a1,1,0,0,1-1.035-.026L4.462,18.03a1,1,0,0,1,.172-1.776L30.667,6.066a1.01,1.01,0,0,1,1,.16,1,1,0,0,1,.35.953L28.014,29.208a1,1,0,0,1-1.434.717l-7.365-3.683L15.72,29.736A.986.986,0,0,1,15.015,30.031Z",
    transform: "translate(-574.017 -1823.015)",
    fill: "#16ebc3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 32,
    height: 32,
    transform: "translate(-572 -1821)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtele);
export default __webpack_public_path__ + "static/media/vtele.6d8837e873e67ca20ac714c5f9f93d51.svg";
export { ForwardRef as ReactComponent };